import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { toast } from "react-toastify";
import ThankYouModal from '../layout/ThankyouModal';

const MYP5SubjectSelectionForm = () => {
  const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => {
        setModalVisible(false);  
      };
  const [signatureImage, setSignatureImage] = useState(null);
  const [signatureImageFile, setSignatureImageFile] = useState(null);
  const [formData, setFormData] = useState({
    studentName: "",
    fatherName: "",
    subjects: {
      group1: "",
      group2: [],
      group3: "",
      group4: "",
      group5: [],
      group6: "",
      compulsory: [],
      optional: [],
    },
  });

  const handleSignatureFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size <= 2 * 1024 * 1024) {
      setSignatureImage(URL.createObjectURL(file));
      setSignatureImageFile(file);
    } else {
      toast.error("File size should be 2MB or less");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (event, group, subject) => {
    const { checked } = event.target;
    setFormData((prevFormData) => {
      let subjects = prevFormData.subjects[group];
      if (group === "group5") {
        subjects = checked
          ? [...subjects, subject]
          : subjects.filter((item) => item !== subject);
      } else {
        subjects = checked ? subject : "";
      }
      return {
        ...prevFormData,
        subjects: {
          ...prevFormData.subjects,
          [group]: subjects,
        },
      };
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const { subjects } = formData;
    if (
      !subjects.group1 ||
      subjects.group2.length === 0 ||
      !subjects.group3 ||
      !subjects.group4 ||
      subjects.group5.length === 0 ||
      !subjects.group6
    ) {
      toast.error("Please select the required subjects.");
      return;
    }

    setModalVisible(true);
    toast.success("Form submitted successfully!");
  };

  return (
    <Box p={2}>
      <Typography variant="h4" align="center" gutterBottom>
        MYP SUBJECT SELECTION FORM FOR MYP 5
      </Typography>
      <Paper elevation={3}>
        <Box p={2}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              sx={{
                marginTop: "0px !important",
                width: "100% !important",
                marginLeft: "0px !important",
              }}
            >
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Student Name"
                  variant="outlined"
                  name="studentName"
                  value={formData.studentName}
                  onChange={handleInputChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Father's Name"
                  variant="outlined"
                  name="fatherName"
                  value={formData.fatherName}
                  onChange={handleInputChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6">
                  SECTION A: SUBJECT SELECTION CRITERIA
                </Typography>
                <Typography variant="body1">
                  Students may select French OR Urdu but not both.
                </Typography>
                <Typography variant="body1">
                  Students are required to select ONE subject per group EXCEPT
                  FOR SCIENCES, in which more than one can be selected.
                </Typography>
                <Typography variant="body1">
                  Interdisciplinary & Personal Project in MYP 5 is compulsory.
                </Typography>
                <Typography variant="body1">
                  * Extended Math students must also attend all Standard Math
                  classes
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6">
                  Please (✓) the selected subjects
                </Typography>
              </Grid>

              <Grid
                container
                spacing={2}
                style={{ backgroundColor: "#f0f0f0", padding: "16px" }}
                sx={{
                  marginTop: "0px !important",
                  marginLeft: "0px !important",
                }}
              >
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" align="center">
                    GROUP 1: LANGUAGE & LITERATURE
                  </Typography>
                  <Grid container spacing={1} direction="column">
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          English
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group1 === "English"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group1", "English")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" align="center">
                    GROUP 2: LANGUAGE ACQUISITION
                  </Typography>
                  <Grid container spacing={1} direction="column">
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Urdu
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group2.includes("Urdu")}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group2", "Urdu")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          French
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group2.includes("French")}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group2", "French")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Arabic
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group2.includes("Arabic")}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group2", "Arabic")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" align="center">
                    GROUP 3: INDIVIDUALS & SOCIETIES
                  </Typography>
                  <Grid container spacing={1} direction="column">
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          History
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group3 === "History"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group3", "History")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Integrated Humanities
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                formData.subjects.group3 === "Integrated Humanities"
                              }
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "group3",
                                  "Integrated Humanities"
                                )
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" align="center">
                    GROUP 4: MATHEMATICS
                  </Typography>
                  <Grid container spacing={1} direction="column">
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Standard
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group4 === "Standard"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group4", "Standard")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Extended
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group4 === "Extended"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group4", "Extended")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" align="center">
                    GROUP 5: SCIENCES
                  </Typography>
                  <Grid container spacing={1} direction="column">
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Physics
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group5.includes("Physics")}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group5", "Physics")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Biology
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group5.includes("Biology")}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group5", "Biology")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Chemistry
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group5.includes("Chemistry")}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group5", "Chemistry")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="h6" align="center">
                    GROUP 6
                  </Typography>
                  <Grid container spacing={1} direction="column">
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Visual Art
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                formData.subjects.group6 === "Visual Art"
                              }
                              onChange={(e) =>
                                handleCheckboxChange(e, "group6", "Visual Art")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Design
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.subjects.group6 === "Design"}
                              onChange={(e) =>
                                handleCheckboxChange(e, "group6", "Design")
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        padding="8px 0"
                      >
                        <Typography variant="body1" flex={1}>
                          Physical & Health Edu
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                formData.subjects.group6 ===
                                "Physical & Health Edu"
                              }
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "group6",
                                  "Physical & Health Edu"
                                )
                              }
                            />
                          }
                          label=""
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                style={{ backgroundColor: "#f0f0f0", padding: "16px" }}
                sx={{
                  marginTop: "16px !important",
                  justifyContent: "center",
                  marginLeft: "0px !important",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="h6" align="center">
                    COMPULSORY
                  </Typography>
                </Grid>
                <Grid item xs={6} align="center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.subjects.compulsory.includes(
                          "Personal Project"
                        )}
                        onChange={(e) =>
                          handleCheckboxChange(
                            e,
                            "compulsory",
                            "Personal Project"
                          )
                        }
                      />
                    }
                    label="Personal Project"
                  />
                </Grid>
                <Grid item xs={6} align="center">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.subjects.compulsory.includes(
                          "Interdisciplinary"
                        )}
                        onChange={(e) =>
                          handleCheckboxChange(
                            e,
                            "compulsory",
                            "Interdisciplinary"
                          )
                        }
                      />
                    }
                    label="Interdisciplinary"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} alignItems="center" 
              sx={{
                marginTop: '15px'
              }}>
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={4}>
                      <Typography variant="h6" align="start">
                        Parent Signature
                      </Typography>
                      <Button
                        variant="contained"
                        component="label"
                        startIcon={<PhotoCamera />}
                      >
                        Upload Signature
                        <input
                          type="file"
                          hidden
                          onChange={handleSignatureFileChange}
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h6" align="start">
                        Student's Signature
                      </Typography>
                      <Button
                        variant="contained"
                        component="label"
                        startIcon={<PhotoCamera />}
                      >
                        Upload Signature
                        <input
                          type="file"
                          hidden
                          onChange={handleSignatureFileChange}
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="h6" align="start">
                        DP Coordinator Signature
                      </Typography>
                      <Button
                        variant="contained"
                        component="label"
                        startIcon={<PhotoCamera />}
                      >
                        Upload Signature
                        <input
                          type="file"
                          hidden
                          onChange={handleSignatureFileChange}
                        />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginTop: "16px" }}
                  type="submit"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Paper>
      <ThankYouModal isVisible={isModalVisible} onClose={closeModal} />
    </Box>
  );
};

export default MYP5SubjectSelectionForm;
